<template>
<div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
  <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
    <Form ref="MandatureForm" @submit="AddMenu" :validation-schema="MenuSchema">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Titre <span class="text-danger">*</span>
          </label>
          <Field name="titre" type="text" class="form-control shadow-none fs-md-15 text-black" />
          <ErrorMessage name="titre" class="text-danger" />
        </div>
      </div>
    
      <div class="col-md-6">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Position <span class="text-danger">*</span>
          </label>
          <Field name="position" type="text" class="form-control shadow-none fs-md-15 text-black" min="0" oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
          <ErrorMessage name="position" class="text-danger" />
        </div>
      </div>
    
      <div class="col-md-4">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Lien <span class="text-danger">*</span>
          </label>
          <Field name="lien" type="text" class="form-control shadow-none fs-md-15 text-black" />
          <ErrorMessage name="lien" class="text-danger" />
        </div>
      </div>
    
      <div class="col-md-4">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Menu<span class="text-danger"></span>
          </label>
    
          <Field name="menu_parent_id" v-slot="{ field }">
          <Multiselect

            :options="MenusOptions"

            :searchable="true"

            track-by="value"

            label="label"

            v-model="selectedParentId"

            placeholder="Sélectionner un menu parent (facultatif)"

            :can-clear="true"

            @change="field.onChange($event)"

          />
          </Field>
          <ErrorMessage name="menu_parent_id" class="text-danger" />
        </div>
      </div>
    
      <div class="col-md-4">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            CategorieArticle<span class="text-danger"></span>
          </label>
          <Field name="categorie_ids" v-slot="{ field }">
          <Multiselect

            :options="categorieArticlesOptions"

            :searchable="true"

            mode="tags"

            track-by="value"

            label="label"

            v-model="selectedCategorieIds"

            placeholder="Sélectionner des catégories"

            @select="field.onChange(selectedCategorieIds)"

            @remove="field.onChange(selectedCategorieIds)"

          />
          </Field>
          <ErrorMessage name="categorie_ids" class="text-danger" />
        </div>
      </div>
      <div class="col-md-6 mt-3">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Image principale
          </label>
          <Field name="image" type="file" accept="image/jpeg, image/png application/pdf"
            class="form-control shadow-none fs-md-15 text-black" placeholder="Choisir une image" />
          <ErrorMessage name="image" class="text-danger" />
        </div>
      </div>
      <div class="col-md-6 mt-3">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Icone
          </label>
          <Field name="icone" type="file" accept="image/jpeg, image/png application/pdf"
            class="form-control shadow-none fs-md-15 text-black" placeholder="Choisir une icone" />
          <ErrorMessage name="icone" class="text-danger" />
        </div>
      </div>
    
      <div class="col-md-12">
        <div class="d-flex align-items-center ">
          <button class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success" type="submit">
            Ajouter
          </button>
          <router-link to="/liste-menus" class=" btn btn-danger transition border-0 lh-1 fw-medium">
          <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
          <span class="position-relative"></span>Annuler
          </router-link>
        </div>
      </div>
    </div>
    </Form>
</div>
</div>
</template>
 
<script lang="ts">

import { defineComponent, onMounted, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import * as Yup from "yup";
import Multiselect from '@vueform/multiselect';
import Swal from "sweetalert2";
export default defineComponent({
  name: "AddMenu",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,

  },
 
  setup: () => {

    const MenuSchema = Yup.object().shape({
      titre: Yup.string().required("Le titre est obligatoire"),
      position: Yup.mixed().required("La position est obligatoire"),
      lien: Yup.mixed().required("Le lien est obligatoire"),
      image: Yup.mixed().notRequired(),
      icone : Yup.mixed().notRequired()

    });
 
    const router = useRouter();
    const MenusOptions = ref([]);
    const categorieArticlesOptions = ref([]);
    const selectedParentId = ref<number | null>(null);
    const selectedCategorieIds = ref<number[]>([]);
    const fetchMenus = async () => {
      try {
        const response = await ApiService.get('/menuss');
        const menusData = response.data.data.data;
        MenusOptions.value = menusData.map((menu) => ({
          value: menu.id,
          label: `${menu.titre}`
        }));

      } catch (error) {
        //
      }
    };

    const fetchCategorieArticles = async () => {
      try {
        const response = await ApiService.get('/categorieArticles');
        const categorieData = response.data.data.data;
        const categoriesData = categorieData.filter(
          (categorie: any) => categorie.isService === "Non"
        );
        categorieArticlesOptions.value = categoriesData.map((cat) => ({
          value: cat.id,
          label: `${cat.nom}`,
        }));
      } catch (error) {
        console.error(error);
      }
    };
 
    // const AddMenu = async (values: any, { resetForm }) => {
    //   try {
    //     const payload = {
    //       titre: values.titre,
    //       lien: values.lien,
    //       position: values.position,
    //       icone : values.icone,
    //       image : values.image,
    //       menu_parent_id: selectedParentId.value, // null si non sélectionné
    //       categorie_ids: selectedCategorieIds.value, // tableau d'IDs
    //     };
    //     console.log("Payload envoyé :", payload);
    //     const response = await ApiService.post("/menus", payload);
    //     Swal.fire({
    //       title: "Menu créé avec succès",
    //       icon: "success",
    //       timer: 1500,

    //     }).then(() => {

    //       resetForm();
    //       router.push("/liste-menus");

    //     });

    //   } catch (error: any) {

    //     console.error("Erreur :", error.response?.data);

    //     Swal.fire({
    //       title: "Erreur",
    //       text: error.response?.data?.message || "Échec",
    //       icon: "error",

    //     });

    //   }

    // };
    const AddMenu = async (values: any, { resetForm }) => {
      try {
        const formData = new FormData();

        formData.append("titre", values.titre);
        formData.append("lien", values.lien);
        formData.append("position", values.position);

        if (values.image && values.image instanceof File) {
          formData.append("image", values.image);
        }
        if (values.icone && values.icone instanceof File) {
          formData.append("icone", values.icone);
        }

        if (selectedParentId.value) {
          formData.append("menu_parent_id", String(selectedParentId.value));
        }

        if (selectedCategorieIds.value && selectedCategorieIds.value.length > 0) {
          selectedCategorieIds.value.forEach((id) => {
            formData.append("categorie_ids[]", String(id));
          });
        }

        console.log("FormData envoyé :", [...formData.entries()]);

        const response = await ApiService.post("/menus", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        Swal.fire({
          title: "Menu créé avec succès",
          icon: "success",
          timer: 1500,
        }).then(() => {
          resetForm();
          router.push("/liste-menus");
        });
      } catch (error: any) {
        console.error("Erreur :", error.response?.data);
        Swal.fire({
          title: "Erreur",
          text: error.response?.data?.message || "Échec",
          icon: "error",
        });
      }
    };

    onMounted(() => {
      fetchMenus();
      fetchCategorieArticles();

    });
 
    return {
      dropzoneOptions: {
        acceptedFiles: 'image/jpeg,image/png',
      },
      AddMenu,
      MenuSchema,
      MenusOptions,
      categorieArticlesOptions,
      selectedParentId,
      selectedCategorieIds,
    };

  },

});
</script>
<style scoped>
@import 'dropzone-vue/dist/dropzone-vue.common.css';
</style>

 